<template>
  <div class="accent">
    <v-container fluid class="py-2">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card elevation="0" class="pg-main-card tw-mt-2 md:tw-mt-4">
            <div class="pg-header">
              <div class="pg-badge">
                <v-icon color="white">mdi-map-marker-radius-outline</v-icon>
              </div>
              <h2 class="pg-title">Regions</h2>
            </div>
            <v-divider class="mb-3" />
            <div class="pg-table">
              <regions-table
                @refreshRegions="fetchRegions"
                :loading-table="loadingTable"
                :regions="regions"
              />
            </div>
          </v-card>
        </v-col>
      </v-row>
      <region-form @refreshRegions="fetchRegions" />
    </v-container>
  </div>
</template>

<script>
import RegionsTable from '@/components/region-management/RegionsTable'
import RegionForm from '@/components/region-management/RegionForm'
import axios from 'axios'
export default {
  name: 'RegionManagement',
  components: {
    RegionForm,
    RegionsTable,
  },
  props: {
    source: String,
  },
  data: () => ({
    dialog: false,
    drawer: null,
    snackback: false,
    loadingTable: true,
    regions: [],
  }),
  mounted() {
    this.fetchRegions()
  },
  methods: {
    fetchRegions() {
      this.loadingTable = true
      this.loadingText = 'Loading... Please wait'
      axios
        .get('/motor-assessment/api/regions')
        .then((res) => {
          this.regions = res.data.data
          this.loadingText = ''
        })
        .catch((err) => {
          this.loadingText =
            err.response && err.response.data
              ? err.response.data.message
              : 'Error loading regions'
          this.$store.commit(
            'SNACKBAR',
            {
              state: 'failed',
              message: `${
                err.response && err.response.data
                  ? err.response.data.msg
                  : 'Failed to fetch regions'
              }`,
              variant: 'error',
            },
            { root: true }
          )
        })
      this.loadingTable = false
    },
  },
}
</script>

<style scoped>
/* Soft-edged card design language (matches BidSubmitted / BidDetails) */
.pg-main-card {
  border-radius: 18px;
  border: 1px solid #e8edf5;
  background: #ffffff;
  padding: 18px 20px 20px;
}
.pg-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}
.pg-badge {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #034ea2 0%, #0a63c4 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 16px rgba(3, 78, 162, 0.25);
}
.pg-title {
  font-size: 20px;
  font-weight: 800;
  color: #0f2a55;
  margin: 0;
}
.pg-table {
  border-radius: 12px;
  border: 1px solid #eef2f8;
  overflow: hidden;
}
.pg-table ::v-deep .v-data-table.elevation-1 {
  box-shadow: none !important;
}
</style>
